<template>
    <div>
        <template>
            <div class="content contentCompetition" v-if="Array.isArray(baseInfoCompetition)&&baseInfoCompetition.length">
                <MiddleTitle title='竞赛信息'></MiddleTitle>
                <table>
                    <thead>
                        <tr>
                            <th>竞赛名称</th>
                            <th>竞赛类别</th>
                            <th>奖项等级</th>
                            <th>获奖时间</th>
                            <th>组织单位</th>
                            <th>获奖类型</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="detailBox" v-for="(value,index) in baseInfoCompetition" :key="index">
                            <td>{{value.name}}</td>
                            <td>{{value.typeName}}</td>
                            <td>{{value.degree}}</td>
                            <td>{{value.date}}</td>
                            <td>{{value.organizationalUnit}}</td>
                            <td>{{value.personalTeamName}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="content contentCompetition" v-else>
                <MiddleTitle title='竞赛信息'></MiddleTitle>
                <img src="@img/xueyezixun/consultant/growthFile/bg_noContent.png"   alt="" style="display: block;margin: 0 auto;"/>
            </div>
        </template>
        <template>
            <div class="content contentCompetition" v-if="Array.isArray(baseInfoComplexQuality)&&baseInfoComplexQuality.length">
                <MiddleTitle title='综合素质'></MiddleTitle>
                <table>
                    <thead>
                    <tr>
                        <th>活动名称</th>
                        <th>活动类别</th>
                        <th>担任角色</th>
                        <th>活动时间</th>
                        <th>组织单位</th>
                        <th>负责老师</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(value,index) in baseInfoComplexQuality" :key="index">
                            <td>{{value.name}}</td>
                            <td>{{value.typeName}}</td>
                            <td>{{value.roleName}}</td>
                            <td v-if="value.startDate!=='null'&&value.endDate!=='null'">
                                {{value.startDate + '—' +value.endDate}}
                            </td>
                            <td v-if="value.startDate=='null'&&value.endDate!=='null'">
                                {{value.endDate}}
                            </td>
                            <td v-if="value.endDate=='null'&&value.startDate!=='null'">
                                {{value.startDate}}
                            </td>
                            <td v-if="value.startDate=='null'&&value.endDate=='null'"></td>
                            <td>{{value.organizationalUnit}}</td>
                            <td>{{value.chargeTeacher}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="content contentCompetition" v-else>
                <MiddleTitle title='综合素质'></MiddleTitle>
                <img src="@img/xueyezixun/consultant/growthFile/bg_noContent.png"   alt="" style="display: block;margin: 0 auto;"/>
            </div>
        </template>
    </div>
</template>
<script>
import MiddleTitle from './middleTitle'
export default {
    props: ['baseInfoCompetition','baseInfoComplexQuality'],
    name: 'pageCompetiton',
    components: {
        MiddleTitle
    },
    data() {
        return {
            imgUrl: 'http://zq.api.chencaiwang.com',
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>